// src/components/layout/Navbar.jsx
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import ConnectWalletButton from "../wallet/ConnectWalletButton";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import logoImage from "../../assets/images/logo.png"; // Adjust the path as necessary

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const mobileNavItems = [
    { name: "Home", href: "/" },
    { name: "My Agents", href: "/my-agents" },
    { name: "Create Agent", href: "/create-agent" },
    { name: "Profile", href: "/profile" },
  ];

  return (
    <nav
      className="backdrop-blur-xl  fixed top-0 left-0 right-0 z-50 h-16 flex items-center 
                   transition-all duration-300 ease-in-out 
                   hover:backdrop-blur-sm"
      style={{ backgroundColor: "#0f1528" }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                src={logoImage}
                alt="Serv Pylon AI Logo"
                className="h-20 w-auto mr-3"
              />
            </Link>
          </div>

          <div className="flex items-center">
            <div className="hidden lg:block">
              <ConnectWalletButton />
            </div>

            <div className="lg:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                type="button"
                className="ml-2 inline-flex items-center justify-center p-2 rounded-md text-slate-200 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white/50 transition-colors"
                aria-controls="mobile-menu"
                aria-expanded={isMobileMenuOpen}
              >
                <span className="sr-only">Open main menu</span>
                {isMobileMenuOpen ? (
                  <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-16 inset-x-0 z-40 transform origin-top shadow-xl">
          <div className="rounded-b-lg bg-slate-800/90 backdrop-blur-md ring-1 ring-black ring-opacity-5 border-t border-slate-100/10 divide-y divide-slate-100/10">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {mobileNavItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    `block px-3 py-3 rounded-md text-base font-medium transition-colors
                    ${
                      isActive
                        ? "bg-slate-700/70 text-blue-300"
                        : "text-slate-200 hover:bg-slate-700/50 hover:text-slate-50"
                    }`
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
            <div className="pt-4 pb-4 px-4">
              <ConnectWalletButton />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
